import Afiche from "./Afiche"

const Month = (props: any) : JSX.Element => {
  return <Afiche />
}
 

export default Month